import { deleteOfficeDivision } from "../../../../../actions/Utilities/OfficeDivision";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteOfficeDivision = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteOfficeDivision(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetOfficeDivision"]);
      toast.fire(
        "Success",
        "OfficeDivision has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate OfficeDivision",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteOfficeDivision;
